/* Shoemageddon hero intro: the wordmark (or assets/logo.png, whichever is
   showing) starts as a speck at the warp vanishing point, tumbles toward the
   viewer through the sneaker storm, slams into place (overshoot + settle,
   screen shake, shockwave ring, sneaker burst), then the copy slides in.
   ~2.4 s, once per page load. Skipped for prefers-reduced-motion, deep links
   (#hash), ?intro=0, or if the page loaded already scrolled. */
(function(){
"use strict";
var H=document.documentElement;
if(!H.classList.contains('intro')) return;
var brand=document.querySelector('.hero .brand');
if(!brand){ H.classList.remove('intro'); return; }
var hero=document.querySelector('.hero'), canvas=document.getElementById('space');
var copy=['.hero .kicker','.hero .tagline','.hero .hero-sub','.hero .hero-ctas','.hero .scroll-cue']
  .map(function(s){return document.querySelector(s);}).filter(Boolean);
var fire=!H.classList.contains('wm-neon')&&!H.classList.contains('wm-white'); // fire is the default theme
var white=H.classList.contains('wm-white');
var FLY=1450, SETTLE=420, COPY0=1520, STAG=110, CDUR=460, END=COPY0+STAG*(copy.length-1)+CDUR; // ~2.42 s
var t0=0, t=0, lastNow=0, waitStart=0, fx, fy, dx0, dy0, impacted=false, mobile=innerWidth<700, lastEmber=0;
var S0=.022, S1=1.12;

function finish(){
  brand.style.transform=brand.style.opacity='';
  copy.forEach(function(el){el.style.transform=el.style.opacity='';});
  hero.style.transform=''; if(canvas) canvas.style.transform='';
  var W=window.ShoeWarp; if(W){W.setBoost(1);W.heat(0,0,0,0);}
  H.classList.remove('intro','intro-fly'); window.__introRunning=false; window.__introDone=true;
}
function measure(){
  var r=brand.getBoundingClientRect(), vp=window.ShoeWarp?ShoeWarp.vanishingPoint():{x:innerWidth/2,y:innerHeight*(mobile?.42:.45)};
  fx=r.left+r.width/2; fy=r.top+r.height/2; dx0=vp.x-fx; dy0=vp.y-fy;
}
function ease3(x){return 1-Math.pow(1-x,3);}
function frame(now){
  if(!H.classList.contains('intro')){ finish(); return; }   // failsafe already revealed it
  window.__introRunning=true;
  // hold (wordmark hidden, warp already running) until sprites + fonts are in, max 1.2 s,
  // so page-load jank doesn't eat the start of the intro
  if(!t0){
    if(!waitStart) waitStart=now;
    var ok=window.ShoeWarp&&ShoeWarp.ready()&&(!document.fonts||document.fonts.status==='loaded');
    if(!ok&&now-waitStart<1200){ requestAnimationFrame(frame); return; }
    t0=lastNow=now; measure(); H.classList.add('intro-fly');
  }
  if(window.scrollY>innerHeight*.5){ finish(); return; }
  t+=Math.min(34,now-lastNow); lastNow=now;   // a dropped frame slows the intro instead of skipping it
  var W=window.ShoeWarp, s, ox=0, oy=0, ry=0, rz=0, rx=0, op=1;
  if(t<FLY){
    var p=t/FLY;
    s=S0*Math.pow(S1/S0,Math.pow(p,1.55));               // exponential = perspective rush
    var k=(s-S0)/(S1-S0); ox=dx0*(1-k); oy=dy0*(1-k);     // travels along the ray from the vanishing point
    ry=900*Math.pow(1-p,1.6); rz=-160*Math.pow(1-p,2.2); rx=24*Math.pow(1-p,2);
    op=Math.min(1,p*7);
    if(W){
      W.setBoost(1+2.6*p*p);
      var hx=fx+ox, hy=fy+oy, size=brand.offsetWidth*s*(mobile?.7:.45);
      W.heat(hx,hy,Math.max(30,size),fire?Math.min(1,p*1.4):Math.min(.4,p*.6),fire?'255,120,20':(white?'200,210,255':'190,120,255'));
      if(fire&&p>.2&&t-lastEmber>32){ lastEmber=t; W.embers(hx,hy,mobile?4:9,size*.5); }
    }
  } else {
    if(!impacted){ impacted=true;
      if(W) W.impact(fx,fy,fire?{c1:'255,150,30',c2:'255,40,10',spread:brand.offsetWidth*.35}:(white?{c1:'255,255,255',c2:'170,190,255',spread:brand.offsetWidth*.35}:{spread:brand.offsetWidth*.35}));
      if(fire&&W) W.embers(fx,fy,mobile?40:110,brand.offsetWidth*.45);
    }
    var q=Math.min(1,(t-FLY)/SETTLE);
    if(q>=1&&H.classList.contains('intro-fly')) H.classList.remove('intro-fly'); // glow filter back once it's still
    s=1+(S1-1)*Math.cos(q*Math.PI*2.4)*Math.exp(-4.2*q)*(q<1?1:0);
    rz=2.2*Math.sin(q*Math.PI*3)*Math.exp(-4*q);
    var amp=(mobile?8:15)*Math.exp(-7*(t-FLY)/1000)*Math.max(0,1-(t-FLY)/420);
    var shx=amp*Math.sin(t*.09)*Math.cos(t*.031), shy=amp*Math.cos(t*.077);
    var sh=amp>.3?'translate('+shx.toFixed(1)+'px,'+shy.toFixed(1)+'px)':'';
    hero.style.transform=sh; if(canvas) canvas.style.transform=sh;
    if(W){ W.setBoost(1+2.6*Math.exp(-(t-FLY)/260)); W.heat(fx,fy,brand.offsetWidth*.3,(fire?.9:.45)*Math.exp(-(t-FLY)/180),fire?'255,120,20':(white?'200,210,255':'190,120,255')); }
  }
  brand.style.opacity=op;
  brand.style.transform='translate('+ox.toFixed(1)+'px,'+oy.toFixed(1)+'px) perspective(700px) rotateX('+rx.toFixed(1)+'deg) rotateY('+ry.toFixed(1)+'deg) rotateZ('+rz.toFixed(2)+'deg) scale('+s.toFixed(4)+')';
  for(var i=0;i<copy.length;i++){
    var c=Math.max(0,Math.min(1,(t-COPY0-i*STAG)/CDUR)), e=ease3(c);
    copy[i].style.opacity=e; if(!copy[i].classList.contains('scroll-cue')) copy[i].style.transform=c<1?'translateY('+(26*(1-e)).toFixed(1)+'px)':'';
  }
  if(t>=END){ finish(); return; }
  requestAnimationFrame(frame);
}
/* wait for the webfonts (max 1.5 s) so the wordmark is measured at its final width */
var fontsReady=(document.fonts&&document.fonts.ready)?document.fonts.ready:Promise.resolve();
window.__introRunning=true; // keep the head failsafe from revealing early while fonts load
Promise.race([fontsReady,new Promise(function(r){setTimeout(r,1500);})]).then(function(){ requestAnimationFrame(frame); });
})();